module.exports = __webpack_public_path__ + "static/media/icon_syunb353a2a1be8f5ee967b475b88fcd44a4.webp";